import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ChangeProfilePage, { getDefaultPageUI } from "components/pages/ChangeProfilePage";
import Classes from "model";
/**
 * @function CaptureZelleSelectProfileDropdownOpen
 * @return {React.Component}
 * @exported true
 * @description Capture component for "003_SelectProfile_DropdownOpen" in capture group "Zelle".
 */
export default function CaptureZelleSelectProfileDropdownOpen(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "currentProfileSelectIsActive" ], true)
    .submit();

    return <ChangeProfilePage ui={ ui } />;
}